import { cn } from "@/lib/utils";
import { ComponentProps } from "react";

type ProductGalleryVideoProps = {
  src: string;
} & ComponentProps<"video">;

export default function ProductGalleryVideo({
  src,
  className,
  ...props
}: ProductGalleryVideoProps) {
  return (
    <video
      className={cn(
        "aspect-portrait h-full w-full object-cover lg:aspect-square",
        className,
      )}
      src={src}
      muted
      playsInline
      autoPlay
      loop
      controls={false}
    />
  );
}
